import Link from "next/link";

import { Anchor, Icon, NewselaSVG } from "@newsela/angelou";

import {
  newselaLogoAnchorCss,
  newselaLogoCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/NewselaLogo/NewselaLogo.styles";

const NewselaLogo = () => {
  return (
    <li>
      <Link href="/home" passHref legacyBehavior>
        <Anchor
          __cssFor={newselaLogoAnchorCss}
          dataProps={{ "data-qa-selector": "global-nav-home", tabIndex: 0 }}
          ariaProps={{ "aria-label": "Go to Home" }}
        >
          <Icon
            isDecorative={false}
            title="Go to Home"
            SvgComponent={NewselaSVG}
            __cssFor={newselaLogoCss}
          />
        </Anchor>
      </Link>
    </li>
  );
};

NewselaLogo.displayName = "NewselaLogo";
export { NewselaLogo };
